import * as React from 'react';
import { Alert as AlertType } from 'src/types';
import Alert from '../Alert/Alert';
import Loading from '../Loading';

export const createAlerts = (alerts: AlertType[], handleUpdateAlert: any, type: any) => {
    if(alerts) {
      return alerts.map((alert: AlertType, index: number) => {
        return (
          <Alert 
            key={index}
            alert={alert} 
            handleUpdateAlert={handleUpdateAlert}
            type={type}
          />
        )
      })
    } else return <Loading />
  }


// WEBPACK FOOTER //
// ./src/components/AlertList/createAlerts.tsx